import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import App from './app';
import { initErrorTracking } from './services/errorTracking';
import { installChunkErrorReload } from './utils/chunkErrorReload';
import { installDomNodeGuard } from './utils/domNodeGuard';

// Neutralise les crashs removeChild/insertBefore causés par les mutations
// DOM externes (Google Translate, extensions navigateur). À installer avant
// tout rendu React. Voir src/utils/domNodeGuard.ts.
installDomNodeGuard();

// Initialiser Sentry avant tout rendu
initErrorTracking();

// Auto-reload sur chunk-loading-error post-deploy. Le flag de garde n'est
// nettoyé que 5 s après window.load → évite la boucle infinie si l'erreur
// se reproduit immédiatement après reload.
installChunkErrorReload();

const rootElement = document.getElementById('root')!;

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
